import { render } from "./WhatsAppFlowsView.vue?vue&type=template&id=db4c15ee&scoped=true"
import script from "./WhatsAppFlowsView.vue?vue&type=script&lang=js"
export * from "./WhatsAppFlowsView.vue?vue&type=script&lang=js"

import "./WhatsAppFlowsView.vue?vue&type=style&index=0&id=db4c15ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db4c15ee"]])

export default __exports__